import { render, staticRenderFns } from "./CityDetailPage.vue?vue&type=template&id=61bdf770&"
import script from "./CityDetailPage.vue?vue&type=script&lang=js&"
export * from "./CityDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports